// extracted by mini-css-extract-plugin
module.exports = {"car-info":"car-info-1jF","dealer-info":"dealer-info-1Rq","labels":"labels-1a6","label":"label-37J"};